import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { EmployeeCertificatesConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { EmployeeCertificatesService } from './api/employeeCertificates.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class EmployeeCertificatesApiModule {
    public static forRoot(configurationFactory: () => EmployeeCertificatesConfiguration): ModuleWithProviders<EmployeeCertificatesApiModule> {
        return {
            ngModule: EmployeeCertificatesApiModule,
            providers: [ { provide: EmployeeCertificatesConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: EmployeeCertificatesApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('EmployeeCertificatesApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
